import { connect } from 'react-redux';
import View from './view';
import { data as financialPlanSelector } from '../FinancialPlanSelector';

const mapStateToProps = (state, ownProps) => {
  const { clientId } = ownProps;
  return {
    generalAssumptions: financialPlanSelector(state, { clientId }).GeneralAssumptions,
  };
};

export default connect(
  mapStateToProps,
  {},
)(View);
